<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="green">
                            <v-toolbar-title class="my-0 py-0">Remitos de Alquiler</v-toolbar-title>
                            <v-spacer></v-spacer>
                            Código: {{ remito }}
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="imprimirAlquiler()">
                                    <v-icon>mdi-printer</v-icon>
                                </v-btn>
                            </div>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="green lighten-4" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="4">
                                    <h6> Fecha: {{ fecha }}</h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    <h6>Remito: {{ remito }}</h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="6">
                                    <h6>Depósito Origen: {{ origen }} </h6>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h6> Depósito Destino: {{ destino }}</h6>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-data-table dense :headers="headers" :items="bienesalquiler" locale="es-ar"
                            class="elevation-1" :items-per-page="500" hide-default-footer>
                        </v-data-table>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <h6> Observaciones: {{ observ }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="8" md="8">
                                    <h6>Transporte: {{ transporte }}</h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6>Valor declarado: {{ valor }}</h6>
                                </v-col>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <h6>Preparó: {{ preparo }}</h6>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <h6>Solicitó: {{ solicito }}</h6>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <h6>Lugar de entrega: {{ lugar }}</h6>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        fecha: "",
        equipo: "",
        listadoequipo: [],
        codgral: "",
        origen: "",
        destino: "",
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
            item: "",
            codgral: "",
            cantidad: ""
        },
        defaultItem: {
            item: "",
            codgral: "",
            cantidad: ""
        },
        listadodeposito: [],
        count: "6",
        bienesalquiler: [],
        alquiler: [],
        headers: [
            { text: "Equipo", value: "detalle", width: "70%", sortable: false },
            { text: "Cantidad", value: "cantidad", width: "20%", sortable: false },
        ],
        codigo: "",
        preparo: "",
        solicito: "",
        observ: "",
        transporte: "",
        lugar: "",
        valor: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
    }),

    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargarRemito();
                }
                return this.visible;

            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    props: ["visible", "remito"],
    methods: {

        cargarRemito() {
            let remito = this.remito;
            let self = this;
            axios
                .get("/SSGG/CargarRemito?", {
                    params: {
                        filtroremito: remito,
                    },
                })
                .then((response) => {
                    self.origen = response.data.origen;
                    self.destino = response.data.destino;
                    self.fecha = response.data.fecha;
                    self.valor = response.data.valor;
                    self.transporte = response.data.transporte;
                    self.lugar = response.data.lugar;
                    self.bienesalquiler = response.data.alquiler;
                    self.preparo = response.data.preparo;
                    self.solicito = response.data.solicito;
                    self.observ = response.data.observ;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        vaciarModels() {
            this.fecha = "";
            this.origen = "";
            this.destino = "";
            this.solicito = "";
            this.realizo = "";
            this.observ = "";
            this.alquiler = [];
            this.transporte = "";
            this.valor = "";
            this.lugar = "";
        },


        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },


        imprimirAlquiler() {

            var vm = this;
            var columns = [
                { title: "Item", dataKey: "item" },
                { title: "Código", dataKey: "codgral" },
                { title: "Bien", dataKey: "detalle" },
                { title: "Cantidad", dataKey: "cantidad" },
            ];

            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);
            doc.line(10, 11, 10, 41);
            doc.line(40, 26, 200, 26);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(12);
            doc.text("ALQUILER DE BIENES", 60, 20);
            doc.setFontSize(10);
            doc.text("Fecha: " + vm.fecha, 155, 20);
            doc.text("Nota Envío: " + vm.remito, 155, 35);
            doc.line(40, 11, 40, 41);
            doc.line(150, 11, 150, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);

            doc.setFontSize(11);

            var final = 50; // Posición vertical inicial
            var i = 0;
            doc.setFontSize(12); // Tamaño de fuente del título
            doc.text("Depósito de Origen: " + vm.origen, 15, 50);
            doc.text("Depósito de Destino: " + vm.destino, 15, 55);
            var final = 60;

            doc.autoTable(columns, vm.bienesalquiler, {
                startY: final,
                theme: 'grid',
                margin: { top: 10 },
            });
            // Actualiza la posición final para la próxima iteración
            final = doc.lastAutoTable.finalY + 10; // Añade 10 para espacio entre tablas

            // Verifica si es necesario agregar una nueva página
            if (final >= 250) {
                doc.addPage();
                final = 10; // Resetea la posición vertical
            }

            doc.text("Preparó: " + vm.preparo, 15, final + 10);
            doc.text("Solicitó: " + vm.solicito, 15, final + 20);
            doc.text("Transporte: " + vm.transporte, 15, final + 30);
            doc.text("Valor Declarado: " + vm.valor, 15, final + 35);
            doc.text("Lugar de entrega: " + vm.lugar, 15, final + 40);
            doc.text("Observaciones: " + vm.observ, 15, final + 45);



            doc.output('dataurlnewwindow');

            // doc.save("Alquileres" + vm.mes + vm.anio + ".pdf");

        },

    },
};
</script>
